const newsletter = `
# eBL Newsletter 22

## 28 May 2026

### Library

- A new interface of the eBL, by Farhan Abdulla, has been released.
- The following collections have been added:
  - Abbey Museum of Art and Archaeology (Caboolture, Australia)
  - Babylon Collection of the İstanbul Arkeoloji Müzeleri (based on the
    recently published BEŞEM 1–3 volumes)
  - Bryn Mawr College Special Collections
  - Katz Center for Advanced Judaic Studies (Philadelphia)
  - Musées royaux d’Art et d’Histoire (Bruxelles)
  - National Museum of World Writing Systems (Incheon, South Korea)
- Numerous new photos have been uploaded:
  - more than 3100 photos from the British Museum’s Babylonian (BM.15000–15999)
    and Sippar Collections (BM.52043–55057)
  - more than 1000 photos from the Yale Peabody Museum’s collections
    (MLC.1–2670, NBC.3714–7881, NBC.12009–12445, YBC.4120–4135, YBC.9821–9873)
  - 29 photos from the Bryn Mawr College Special Collections (BMC.T.46–362,
    BMC.2009-18.1–19), photographed by I. Russell
  - 17 photos from the Vorderasiatisches Museum (VAT.227–298, VAT.7824–7897),
    mostly from the Hellenistic and Arsacid periods
  - 9 photos from the Abbey Museum of Art and Archaeology (Abbey-W.588–596),
    photographed by P. Zilberg 
  - 5 photos from various collections in Türkiye: the Adana Arkeoloji Müzesi,
    the Anadolu Medeniyetleri Müzesi, the Hatay Archaeology Museum and the
    Kayseri Arkeoloji Müzesi.
- Text editions: ADART 7 has been converted to eBL-ATF and imported, courtesy
  of H. Hunger.
- Archaeology: A repertoire of the recoverable findspots of Nineveh tablets,
  compiled by S. Cohen-Olberding in the framework of the AHRC/DFG project
  “Reading the Library of Ashurbanipal: A Multi-sectional Analysis of
  Assyriology’s Foundational Corpus”
  ([DFG project page](https://gepris.dfg.de/gepris/projekt/428991681)), has
  been imported onto the eBL Records of Nineveh tablets. See also
  [https://www.ebl.lmu.de/about/archaeology](https://www.ebl.lmu.de/about/archaeology).
- Dossiers:
  - It is now possible to search for dossiers.
  - Anu-ikṣur and Iqīšāya dossiers have been added, and all tablets belonging
    to them classified as such.
- References: It is now possible to use advanced Markdown in reference notes,
  e.g. ^d^ for superscript.
  
### Tools

- Dictionary: It is now possible to add new lemmata. This is particularly
  relevant for the lemmatisation of proper nouns that are not yet in the
  dictionary. When adding new proper nouns, please adhere to the conventions
  outlined here:
  [generic-documentation/guides/properNames.md at master · ElectronicBabylonianLiterature/generic-documentation](https://github.com/ElectronicBabylonianLiterature/generic-documentation/blob/master/guides/properNames.md)

### Corpus

- A.C. Lenzi’s editions of the *šuʾila*s to Šamaš and the *šuʾila* to Dilbat
  have been uploaded.`

export default newsletter
